export { withHistoryService } from "./with-history-listener-context";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../es/hocs/index.js
// module id = 1135
// module chunks = 0